(function () {
    'use strict';

    angular
        .module(app.modules.common.name)
        .directive('xxFileUpload', xxFileUpload);

    var INVALID_FILE_TYPE = 'Invalid file type.',
        FILE_SIZE_EXCEEDED = 'Media exceeds maximum size of {0}.';        

    xxFileUpload.$inject = ['$q'];
    function xxFileUpload($q) {
        var result = { restrict: 'A', controller: FileUploadCtrl };

        FileUploadCtrl.$inject = ['$scope', '$element', '$attrs', '$parse', '$filter', 'fileReader', 'fileAcceptCompiler'];
        function FileUploadCtrl($scope, $element, $attrs, $parse, $filter, fileReader, fileAcceptCompiler) {
            var vm = this,
                cancellationTokens = {},
                isValidFileType = defaultIsValidFile,
                maxFileSizeGetter = $parse($attrs['xxMax']),
                formatFileSize = $filter('filesize');

            vm.fileload = null;
            vm.fileerror = null;
            vm.fileprogress = null;
            vm.clear = clear;

            if ($attrs.xxFileUpload) 
                $scope[$attrs.xxFileUpload] = this;

            $scope.$on('$destroy', onDestroy);
            $attrs.$observe('accept', acceptWatch);

            if ($element[0] instanceof HTMLInputElement && $attrs.type === 'file') {
                $element.on('change', onChange);
            }

            function onChange(e) {
                if (vm.fileload || vm.fileerror || vm.fileprogress) {
                    angular.forEach(e.target.files, handleFile);
                    $element.val(null);
                }
            }

            function handleFile(file) {
                var tokenId = angular.guid(),
                    promise,
                    maxSize = maxFileSizeGetter() || Infinity;

                promise = !isValidFileType(file) ? $q.reject({ file: file, error: INVALID_FILE_TYPE, event: null })
                    : file.size > maxSize ? $q.reject({ file: file, error: FILE_SIZE_EXCEEDED.format(formatFileSize(maxSize)), event: null })
                    : fileReader(file, null, cancellationTokens[tokenId] = {}).catch(appendRetryHandler).finally(complete);

                promise = promise.then(vm.fileload, vm.fileerror, vm.fileprogress);

                function complete() {
                    delete cancellationTokens[tokenId];
                }
                function appendRetryHandler(reason) {
                    reason.retry = handleFile.bind(null, file);
                    return $q.reject(reason);
                }
            }
            
            function onDestroy() {
                $element.off('change', onChange);
                angular.forEach(cancellationTokens, cancel);

                function cancel(cancellationToken) {
                    cancellationToken.cancel();
                }
            }

            function acceptWatch(value) {
                isValidFileType = fileAcceptCompiler(value);
            }

            function defaultIsValidFile() {
                return true;
            }

            function clear() {
                $element.prop('value', null);
            }
        }

        return result;
    }
})();